(function() {

    'use strict';

    /**
     * @module Plugins
     *
     * This plugin provides a way of sending KPI events to remote endpoints.
     *
     * Uses images to fire and forget.
     *
     * @namespace overlay
     */

    /**
     * @module Messages
     *
     * Displays content on top of the video.
     * Currently only substitles are supported (kind === 'sub').
     *
     * @function add_overlay
     * @param {String}    messageKind='add_overlay'
     * @param {Object}    ol
     * @param {String}    ol.kind  (currently 'sub' is supported, for subtitles display)
     * @param {String}    ol.id    entity id
     * @param {String[]}  ol.lines text content to display
     */

    /**
     * Used to remove overlay elements from the view.
     *
     * @function remove_overlay
     * @param {String} messageKind='remove_overlay'
     * @param {String} id
     */

    /**
     * Used to remove several overlay elements from the view.
     *
     * @function remove_overlay_prefix
     * @param {String} messageKind='remove_overlay_prefix'
     * @param {String} idPrefix
     */



    var plugin = function(vc, ui) {
        this._vc = vc;
        this._ui = ui;

        this._el = document.createElement('div');
        this._el.className = 'fill overlay';
        ui._els.overlay = this._el;

        this._ui._els.aEl.appendChild(this._el);

        this._vc.subscribe('add_overlay load remove_overlay remove_overlay_prefix', undefined, this);
    };

    plugin.prototype = {

        _name: plugin._name = 'overlay',

        on_load: function() {
            this._el.innerHTML = '';
        },

        on_add_overlay: function(mt, ol) {
            var markup;
            switch (ol.kind) {
                case 'subtitle':
                markup = [
                    '<div',
                        ' id="', ol.id, '"',
                        ' class="sub">',
                        '<p>',
                        ol.lines.join('</p><p>'),
                        '</p>',
                    '</div>'
                ];
                break;
            }

            this._el.insertAdjacentHTML('beforeend', markup.join(''));
        },

        on_remove_overlay: function(mt, id) {
            var el = s$(id);
            if (el && el.parentNode) {
                this._el.removeChild(el);
            }
        },

        on_remove_overlay_prefix: function(mt, idPrefix) {
            var el = this._el.lastChild;

            if (!el) { return; }

            do {
                if (el.parentNode && el.id && el.id.indexOf(idPrefix) === 0) {
                    this._el.removeChild(el);
                }

                el = el.previousSibling;
            } while (el);
        }
    };

    SAPO.Project.Video.Controllers._plugins.push(plugin);

})(undefined);
